import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ModuleWithProviders,
  NgModule,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { AngularMaterialLibsModule } from './angular-material-libs.module';
import { MultiDragComponentComponent } from './component/multi-drag-component/multi-drag-component.component';
import { MultiDragParentComponentComponent } from './component/multi-drag-parent-component/multi-drag-parent-component.component';
import { BannerComponent } from './components/banner/banner.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { AppDatePickerComponent } from './components/datepicker/app-datepicker';
import { IframeComponent } from './components/iframe/iframe.component';
import { BackButtonDirective } from './directive/back-button.directive';
import { ImagePreviewDirective } from './directive/image-preview.directive';
import { ProductMenuHoverDirective } from './directive/product-menu-hover.directive';
import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { NoNullPipe } from './pipes/no-null.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { StatusPipe } from './pipes/status.pipe';
import { SharedLibsModule } from './shared-libs.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    BannerComponent,
    AppDatePickerComponent,
    ImagePreviewDirective,
    MultiDragComponentComponent,
    MultiDragParentComponentComponent,
    ConfirmModalComponent,
    StatusPipe,
    BackButtonDirective,
    SafePipe,
    NoNullPipe,
    CustomDatePipe,
    CustomCurrencyPipe,
    ProductMenuHoverDirective,
    IframeComponent,
  ],
  imports: [
    CommonModule,
    SharedLibsModule,
    TranslateModule,
    AngularMaterialLibsModule,
    LazyLoadImageModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    DragDropModule,
    FileUploadModule,
    InfiniteScrollModule,
  ],
  exports: [
    SharedLibsModule,
    TranslateModule,
    AngularMaterialLibsModule,
    LazyLoadImageModule,
    NgxMatSelectSearchModule,
    BannerComponent,
    AppDatePickerComponent,
    ImagePreviewDirective,
    FileUploadModule,
    MultiDragComponentComponent,
    MultiDragParentComponentComponent,
    StatusPipe,
    BackButtonDirective,
    SafePipe,
    NoNullPipe,
    CustomDatePipe,
    CustomCurrencyPipe,
    IframeComponent,
    InfiniteScrollModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [CurrencyPipe],
  entryComponents: [ConfirmModalComponent, IframeComponent],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
